<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Pay Status"
      text="Update pay status"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col cols="12">
              <span 
                v-if="localPayStatus" 
                class="font-weight-medium px-3 green--text"
              >
                ACTIVE
              </span>
              <span 
                v-else 
                class="font-weight-medium px-3 red--text"
              >
                INACTIVE
              </span>
              <v-sheet class="px-5 my-n2">
                <v-switch
                  v-model="localPayStatus"
                  inset
                />
              </v-sheet>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      companyEmployee: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        loading: false,
        localPayStatus: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.localPayStatus = this.companyEmployee.is_active_pay_status 

        this.loading = false
      },
    },
    methods: {
      submitForm () {
        this.progressing = true

        this.$api.hrisCompanyEmployees().updateCompanyEmployee(this.companyEmployee.company_employee_uid, this.prepareFormData())
          .then(response => {
            if (response.status === 200) {
              this.$emit('updated')
              this.$snack({ message: response.data.status })
            }
          })
          .catch(() => {
            this.$snack({ color: 'error', message: 'Error! Unable to update pay status.' })
          })
          .then(() => {
            this.dialog = false
            this.loading = false
            this.progressing = false
          }) 
      },
      prepareFormData () {
        return {
          is_active_pay_status: this.localPayStatus,
        }
      },
    },
  }
</script>
